export default "__VITE_ASSET__Cw83Eijn__"